import React, { useState } from "react";
import "./Login.css"; // folosim același CSS ca la Login

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch(
        "https://www.fro.ro/api/clubs/forgot_password.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        }
      );

      const data = await res.json();
      setMessage(data.message);
    } catch {
      setMessage("Eroare la conexiune.");
    }
  };

  return (
    <div className="login-bg">
      <div className="login-card">
        <div className="login-logo">Federația Română de Orientare</div>
        <h2 className="login-title">Recuperare parolă</h2>
        <form onSubmit={handleSubmit} className="login-form">
          <label className="login-label">Email</label>
          <input
            type="email"
            className="login-input"
            placeholder="Introduceți emailul clubului"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button type="submit" className="login-btn" style={{ marginTop: 20 }}>
            Trimite link de resetare
          </button>
        </form>
        {message && <p className="login-message">{message}</p>}
      </div>
    </div>
  );
}
